import React, { useState } from "react";
import "./Contact.css";

export default function ContactForm() {
    const [selectedDealer, setSelectedDealer] = useState("");
    const [selectedPincode, setSelectedPincode] = useState("");

    const dealers = [
        {
            name: "M/S Luv Kush Agro",
            pincode: "801301",
            contactPerson: "Luv Kush",
            location: "Patna, Bihar - 801301, INDIA",
            contact: "0123-4567890",
            email: "luv@agro.com",
        },
        {
            name: "M/s Harnam Agri Equipments",
            pincode: "335001",
            contactPerson: "Harman",
            location: "Sri Ganga Nagar, Rajasthan - 335001, INDIA",
            contact: "0180-0532672",
            email: "sales@dasmesh.com",
        },
        {
            name: "M/s Shailesh Agro Motors & Machinery",
            pincode: "560001",
            contactPerson: "Shailesh",
            location: "Bangalore, Karnataka - 560001, INDIA",
            contact: "0911-2233445",
            email: "shailesh@agro.com",
        },
    ];

    // Filter dealers based on selected criteria
    const filteredDealers = dealers.filter(
        (dealer) =>
            (!selectedDealer || dealer.name === selectedDealer) &&
            (!selectedPincode || dealer.pincode === selectedPincode)
    );

    return (
        <>
            <div className="contact-form-contact">
                <div className="dealer-contact-form">
                    <h3>FIND YOUR DEALER</h3>
                    <div className="filters">
                        <select
                            value={selectedDealer}
                            onChange={(e) => setSelectedDealer(e.target.value)}
                        >
                            <option value="">Select Dealer</option>
                            {dealers.map((dealer, index) => (
                                <option key={index} value={dealer.name}>
                                    {dealer.name}
                                </option>
                            ))}
                        </select>
                        <select
                            value={selectedPincode}
                            onChange={(e) => setSelectedPincode(e.target.value)}
                        >
                            <option value="">Select Pincode</option>
                            {dealers
                                .map((dealer) => dealer.pincode)
                                .filter((pincode, index, self) => self.indexOf(pincode) === index)
                                .map((pincode, index) => (
                                    <option key={index} value={pincode}>
                                        {pincode}
                                    </option>
                                ))}
                        </select>
                    </div>
                    <div className="dealer-list">
                        {filteredDealers.map((dealer, index) => (
                            <div className="dealer-card" key={index}>
                                <div className="dealer-name">
                                    <h3>{dealer.name}</h3>
                                    <h4>{dealer.contactPerson}</h4>
                                </div>
                                <div className="dealer-location">
                                    <h3>{dealer.location}</h3>
                                    <h4 className="dealer-contact">{dealer.contact}</h4>
                                </div>
                                <div className="dealer-email">{dealer.email}</div>
                            </div>
                        ))}
                        {filteredDealers.length === 0 && (
                            <div>No dealers match the selected criteria.</div>
                        )}
                    </div>
                </div>
            </div>
        </>

    );
}
